import React from 'react';
import { Typography, Box, TextField } from '@mui/material';

import type { SupplierRegistrationForm, TransportVehicles } from '../../types/company.types';

import { getStylesForEditableField } from '@/utils/helpers';
import { PaperBoxStyles } from '@/components/styles';

interface TransportVehiclesSectionProps {
  transportVehicles: TransportVehicles;
  originalTransportVehicles?: TransportVehicles;
  isEditMode?: boolean;
  onUpdateTransportVehicleField: (
    field: keyof SupplierRegistrationForm['transportVehicles'],
    value: string | number
  ) => void;
  getFieldError: (field: string) => string | undefined;
  isFieldValid: (field: string) => boolean;
}

export const TransportVehiclesSection: React.FC<TransportVehiclesSectionProps> = ({
  transportVehicles,
  originalTransportVehicles,
  isEditMode,
  onUpdateTransportVehicleField,
  getFieldError,
  isFieldValid,
}) => {
  const vehicleFields = [
    { key: 'large10t', label: '大型10t', unit: '台' },
    { key: 'medium8t', label: '中型8t', unit: '台' },
    { key: 'size7t', label: '7t', unit: '台' },
    { key: 'size5t', label: '5t', unit: '台' },
    { key: 'small4t', label: '小型4t', unit: '台' },
    { key: 'size3t', label: 'm3型3t', unit: '台' },
    { key: 'size2t', label: '2t', unit: '台' },
    { key: 'other', label: 'その他' },
  ];

  const handleNumericChange = (fieldKey: string, value: string) => {
    onUpdateTransportVehicleField(
      fieldKey as keyof SupplierRegistrationForm['transportVehicles'],
      value
    );
  };

  return (
    <PaperBoxStyles elevation={1} sx={{ paddingBottom: '32px' }}>
      <Typography
        variant='h5'
        fontWeight='bold'
        sx={{
          mb: 3,
          color: '#1A1C20',
          fontSize: '22px',
          fontWeight: 600,
        }}
      >
        運搬車
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {vehicleFields.map((field) => {
          const fieldLabel = field.unit ? `${field.label}（${field.unit}）` : field.label;
          const maxLength = field.key === 'other' ? 1000 : 9;

          return (
            <TextField
              key={field.key}
              label={fieldLabel}
              value={transportVehicles[field.key as keyof TransportVehicles]}
              placeholder={`台数を入力してください（半角数値）`}
              onChange={(e) => handleNumericChange(field.key, e.target.value)}
              error={!isFieldValid(`transportVehicles.${field.key}`)}
              helperText={getFieldError(`transportVehicles.${field.key}`)}
              fullWidth
              slotProps={{
                input: {
                  inputProps: {
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    maxLength: maxLength,
                  },
                  sx: getStylesForEditableField(
                    !!isEditMode,
                    originalTransportVehicles?.[field.key as keyof TransportVehicles],
                    transportVehicles[field.key as keyof TransportVehicles]
                  ),
                },
              }}
            />
          );
        })}
      </Box>
    </PaperBoxStyles>
  );
};
